/**
 * Just view/template component, no model/data logic!
 */
import React from "react"
import Img from 'gatsby-image'
import Image from "../../image"

// s4n
import { Link } from "gatsby-plugin-intl"
import GeneralUtils from './../../../utils/common'
import kebabCase from "lodash.kebabcase"
// import "./../../assets/sass/templates/node/_blog.scss"
import BlogCard from './../Blog/card'



const ComponentStateless = (props) => {
  const { data, intl, translate: t } = props; // alias t === translate function

  const linkMap = {
    pl: {
      blog: `Blog`,
      news: `Aktualnosci`,
    },
    en: {
      blog: `Blog`,
      news: `News`,
    },
    de: {
      blog: `Blog`,
      news: `Aktualisierungen`,
    },
    es: {
      blog: `blog`,
      news: `Actualizaciones`,
    }
  }

  const linkTranslation = kebabCase(linkMap[intl.locale][data.pageContext.field_type]);

  return (
    <React.Fragment>
      <section id="blog" className="blog">
        <div className="container">
          <div className="row">

            {/* @see: https://hackernoon.com/5-techniques-to-iterate-over-javascript-object-entries-and-their-performance-6602dcb708a8 */}
            {data.aDataCollectionTranslated.map(({ node }) => {
              return <BlogCard node={node} linkTranslation={linkTranslation} />
            })}

          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default ComponentStateless